import React from 'react'

import PersonIcon from '@mui/icons-material/Person'
import { Avatar, Dialog, DialogTitle, List, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material'

type DataChangeRequestsUsersDialogProps = {
  open: boolean
  onClose: (...args: any[]) => any
  users?: {
    userId: number
    userName: string
  }[]
}

const DataChangeRequestsUsersDialog = ({ onClose, open, users }: DataChangeRequestsUsersDialogProps) => {
  const handleListItemClick = () => {
    onClose()
  }

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>Select user that reported</DialogTitle>
      <List>
        {(users ?? []).map(({ userId, userName }) => (
          <a
            href={`/users/${userId}`}
            key={userId}
            onClick={handleListItemClick}
            rel="noopener noreferrer"
            target="_blank">
            <ListItemButton>
              <ListItemAvatar>
                <Avatar>
                  <PersonIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={userName} />
            </ListItemButton>
          </a>
        ))}
      </List>
    </Dialog>
  )
}

export default DataChangeRequestsUsersDialog
